// 格式化日期
export const formatTime = (date) => {
    var dateStr = date
    if (dateStr) {
        var year = dateStr.slice(0, 4)
        var month = dateStr.slice(4, 6)
        var day = dateStr.slice(6);
        var formatted = year + "-" + month + "-" + day
        return formatted
    }
}

// 格式化数时间戳
export const timestamp = (date) => {
    let time = date * 1000
    return formatTime(time)
}

// 去除CN
export const substring = (date) => {
    return date.slice(2);
}

// 根据专利号判断类型前缀CN
export const istpye = (date) => {
    if (date) {
        var type = date.slice(6, 7)
        if (type == "1" || type == "8") {
            return "发明专利"
        } else if (type == "2" || type == "9") {
            return "实用新型"
        } else if (type == "3") {
            return "外观专利"
        } else {
            return "其它类型"
        }
    }
}

// 根据专利号判断类型无前缀CN
export const Formattype = (date) => {
    if (date) {
        var type = date.slice(4, 5)
        if (type == "1" || type == "8") {
            return "发明专利"
        } else if (type == "2" || type == "9") {
            return "实用新型"
        } else if (type == "3") {
            return "外观专利"
        } else {
            return "其它类型"
        }
    }
}

// 转化时间戳
export const TimeDate = (date) => {
    return date.getTime()
}
// 转换年月日
export const getMonth = (date) => {
    var dateStr = new Date(date);
    // 使用Date对象的方法获取年、月、日等
    var year = dateStr.getFullYear();
    var month = dateStr.getMonth() + 1; // getMonth() 返回的月份是从0开始的，所以需要加1
    var day = dateStr.getDate();
    // 格式化日期
    var formattedDate = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    return formattedDate
}
// 转换时分
export const getfloor = (date) => {
    var shi = Math.floor(date / 60)
    var fe = date % 60
    return shi + "时" + fe + "分"
}
// 时间戳格式化详细时间
export const formatTimestamp = (timestamp) =>{
    const date = new Date(timestamp);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// 时间戳格式化详细时间
export const sfmTime = (timestamp) =>{
    const date = new Date(timestamp);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
}